import React, { Component } from 'react'
import { connect } from 'react-redux'
import { makeCancelable } from '@/utils/cancelablePromise'
import { getTranslation } from '@/store/getters'

import styles from './styles.scss'

/** Components */
import FontManager from '@/components/commons/FontManager/FontManager'
import { downloadFullFont, setCustomFonts } from '@/components/commons/FontManager/fontDownload'
import { getUser } from '@/store/getters'
class FontFamily extends Component {
  state = {
    showOptions: false,
    fonts: [],
    searchFonts: [],
  }

  componentDidMount() {
    const { user } = this.props

    this.fontManager = new FontManager(
      'AIzaSyAeEosl24xCCLXzz9y96kX1R1qQWaJhTIM',
      'Open Sans',
      {
        sort: 'alphabetical'
      },
      this.onFontChange, user.user.email
    )

    this.cancelabePromise = makeCancelable(this.fontManager.init())
    this.cancelabePromise.promise
      .then(() => {
        this.fontManager.getUserFonts()
          .then(() => {
            this.setState({
              fonts: this.fontManager.fonts.map(i => i.name ? i.name : i.family)
            }, () => this.handleFontDownloads())
            this.fontManager.fonts.sort
          })
      })
      .catch(err => console.log(err))
  }

  componentWillUnmount() {
    this.cancelabePromise.cancel()
  }

  handleFontDownloads = () => {
    if (this.previewsDownloaded) return

    this.fontManager.fonts.map(font => {
      if (font.path) {
        setCustomFonts(font.name, font.path)
      } else {
        downloadFullFont(font, `${font.family.replace(/\s\S/gi, '')}`, ['normal'])
      }
      return font
    })
    this.previewsDownloaded = true
  }

  handleChangeFont = (font) => {
    this.setState({ showOptions: false, label: font })

    this.fontManager.setActiveFont(font)
    this.props.onChange(
      this.fontManager.activeFont.family,
      this.fontManager.styleManager
    )
  }

  handleSearchFont = search => {
    const { fonts } = this.state
    const searchFonts = fonts.filter(font => (
      font.toLowerCase().indexOf(search.toLowerCase()) !== -1
    ))

    this.setState({ searchFonts })
  }

  render() {
    const { fonts: allFonts, searchFonts } = this.state
    const { label } = this.props

    const fonts = !!searchFonts.length ? searchFonts : allFonts

    fonts.sort()

    return (
      <div>
        <select className={styles['select']}
          value={label}
          onChange={e => this.handleChangeFont(e.target.value)}
        >
          {fonts.map((fontFamily, index) => (
            <option
              key={index}
              value={fontFamily}
              style={{ fontFamily }}
            >
              {fontFamily}
            </option>
          ))
          }
        </select>
      </div >
    )
  }

}

const mapStateToProps = (state) => {
  const user = getUser(state)
  const translation = getTranslation(state)
  return {
    user,
    translation
  }
}

export default connect(mapStateToProps)(FontFamily) 



// WEBPACK FOOTER //
// ./src/components/editors/FontFamily/index.js